import React from 'react';
import { PropTypes } from 'prop-types';
import { emDashUnicode } from '../../../utilities/constants';

const MakeModelComments = ({ comments }) => {
  if (comments.length === 0) {
    return <div>{emDashUnicode}</div>;
  }

  const tableStyle = { all: 'revert' };
  const tdStyle = {
    all: 'revert',
    paddingRight: '2rem',
    paddingBottom: '0.75rem',
  };
  const lastTdStyle = { ...tdStyle, paddingRight: 0 };

  const getActionText = (action) => {
    switch (action) {
      case 'Add':
        return 'Created and approved';
      case 'Approve':
        return 'Approved';
      case 'Consolidate':
        return 'Consolidated';
      case 'Edit':
        return 'Edited and approved';
      case 'Reject':
        return 'Rejected';
      case 'Request':
        return 'Requested';
      default:
        return emDashUnicode;
    }
  };

  return (
    <table style={tableStyle}>
      {comments.map((c) => (
        <tr key={c.id}>
          <td style={tdStyle}>
            {c.createdAt
              ? new Date(c.createdAt).toLocaleDateString('en-US', {
                  month: '2-digit',
                  day: '2-digit',
                  year: 'numeric',
                })
              : emDashUnicode}
          </td>
          <td style={tdStyle}>
            {c.createdByUser?.fullName || c.createdBy || emDashUnicode}
          </td>
          <td style={tdStyle}>{getActionText(c.action)}</td>
          <td style={lastTdStyle}>{c.comment || emDashUnicode}</td>
        </tr>
      ))}
    </table>
  );
};

MakeModelComments.propTypes = {
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      comment: PropTypes.string,
      createdAt: PropTypes.string,
      createdBy: PropTypes.string,
      createdByUser: PropTypes.shape({
        email: PropTypes.string,
        fullName: PropTypes.string,
      }),
    }),
  ).isRequired,
};

export default MakeModelComments;
